import { postData } from './api';
import { getOfferViewEndpoint, getSubscriptionViewEndPoint } from './constants';
import { getViewedOffers, setViewedOffers } from './settings';
import { logger } from './logger';
import { logRuntimeError } from './utils';

export const setOfferViewed = async ({
  mr_offer_id,
  cartPageDiscountConfig,
  checkDiscount,
  isDiscountCodeEnabled,
}) => {
  try {
    const viewed = getViewedOffers();
    if (viewed[mr_offer_id]) {
      return;
    }

    // if offer is viewed for the first time, there is a possibility that the discount is
    // already applicable so check and update the discount values in the UI
    if (checkDiscount && cartPageDiscountConfig) {
      const check = async () => {
        const cartDiscountModule = await import('../cartDiscount');
        await cartDiscountModule.checkAndUpdateCartDiscount({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      };
      await check();
    }
    await postData(getOfferViewEndpoint(), { mr_offer_id });
    setViewedOffers({ mr_offer_id });
  } catch (error) {
    logRuntimeError({
      errorMessage: `${error.name} ${error.message}`,
      errorData: {
        fileName: 'offer',
        level: 'error',
        functionName: 'setOfferViewed',
      },
      errorStack: error,
    });
    logger.log(error);
  }
};

export const setSubscriptionViewed = async ({
  mr_offer_id,
  cartItemsSubscriptionData,
  mrCart,
}) => {
  try {
    const subscriptionProductsData = [];
    cartItemsSubscriptionData.forEach(elem => {
      if (elem.sellingPlanGroups) {
        subscriptionProductsData.push({
          sp_product_id: mrCart[elem.cartIndex].sp_product_id,
          sp_variant_id: elem.variantID,
        });
      }
    });

    const payLoad = { mr_offer_id, cart: subscriptionProductsData };

    await postData(getSubscriptionViewEndPoint(), { ...payLoad });
  } catch (error) {
    logger.log(error);
  }
};
